import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { Permission, UserPermissionModel } from '../../core/models/classes/permission';
import { UserpermissionService } from '../../core/services/user-permission.service';

@Component({
  selector: 'app-permission',
  templateUrl: './permission.component.html',
  styleUrls: ['./permission.component.scss'],
})

export class PermissionComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private permissionService: UserpermissionService
  ) {}
  isRedViewChecked;
  isRedAccessChecked;
  isBuildingViewChecked;
  isBuildingAccessChecked;
  isTrenchViewChecked;
  isTrenchAccessChecked;
  isDuctViewChecked;
  isDuctAccessChecked;
  isCableViewChecked;
  isCableAccessChecked;
  permissions: UserPermissionModel[] = [];
  ngOnInit(): void {
    //this.getUserPermission();
  }

  getUserPermission() {
    this.permissionService.getPermission(this.data).subscribe({
      next: (data) => {
        this.permissions = data;
        this.permissions.forEach((e) => {
          if (e.moduleId === 1) {
            if (e.permissions === 1) {
              this.isBuildingAccessChecked = true;
              this.isBuildingViewChecked = true;
            } else if (e.permissions === 2) {
              this.isBuildingViewChecked = true;
            }
          }
          if (e.moduleId === 2) {
            if (e.permissions === 1) {
              this.isTrenchAccessChecked = true;
              this.isTrenchViewChecked = true;
            } else if (e.permissions === 2) {
              this.isTrenchViewChecked = true;
            }
          }
          if (e.moduleId === 3) {
            if (e.permissions === 1) {
              this.isDuctAccessChecked = true;
              this.isDuctViewChecked = true;
            } else if (e.permissions === 2) {
              this.isDuctViewChecked = true;
            }
          }
          if (e.moduleId === 4) {
            if (e.permissions === 1) {
              this.isCableAccessChecked = true;
              this.isCableViewChecked = true;
            } else if (e.permissions === 2) {
              this.isCableViewChecked = true;
            }
          }
          if (e.moduleId === 5) {
            if (e.permissions === 1) {
              this.isRedAccessChecked = true;
              this.isRedViewChecked = true;
            } else if (e.permissions === 2) {
              this.isRedViewChecked = true;
            }
          }
        });
      },
    });
  }

  updatepermissionChange(event: MatSlideToggleChange) {
    let permission = new UserPermissionModel();
    permission.Id=0;
    permission.moduleId = 5;
    permission.userId = this.data;
    if (this.isRedViewChecked) {
      permission.permissions = Permission.View;
    } else if (this.isRedAccessChecked) {
      permission.permissions = Permission.Access;
    } else {
      permission.permissions = Permission.None;
    }
    this.permissionService
      .updateUserPermission(+this.data, permission)
      .subscribe({
        next: (data) => {

        },
      });
  }
}
